import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVps = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "server",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "ç¼ç»",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Rectangle",
					d: "M18.3333 1.66669H1.66667V8.33335H18.3333V1.66669Z",
					stroke: "",
					strokeWidth: 1.4,
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Rectangle Copy",
					d: "M18.3333 11.6667H1.66667V18.3334H18.3333V11.6667Z",
					stroke: "",
					strokeWidth: 1.4,
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Rectangle 54 Copy 3",
					d: "M5.41667 4.16669H4.58334C4.35322 4.16669 4.16667 4.35324 4.16667 4.58335V5.41669C4.16667 5.64681 4.35322 5.83335 4.58334 5.83335H5.41667C5.64679 5.83335 5.83334 5.64681 5.83334 5.41669V4.58335C5.83334 4.35324 5.64679 4.16669 5.41667 4.16669Z",
					fill: ""
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Rectangle 54 Copy 5",
					d: "M5.41667 14.1667H4.58334C4.35322 14.1667 4.16667 14.3532 4.16667 14.5834V15.4167C4.16667 15.6468 4.35322 15.8334 4.58334 15.8334H5.41667C5.64679 15.8334 5.83334 15.6468 5.83334 15.4167V14.5834C5.83334 14.3532 5.64679 14.1667 5.41667 14.1667Z",
					fill: ""
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Rectangle 54 Copy 4",
					d: "M8.75 4.16669H7.91667C7.68655 4.16669 7.5 4.35324 7.5 4.58335V5.41669C7.5 5.64681 7.68655 5.83335 7.91667 5.83335H8.75C8.98012 5.83335 9.16667 5.64681 9.16667 5.41669V4.58335C9.16667 4.35324 8.98012 4.16669 8.75 4.16669Z",
					fill: ""
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Rectangle 54 Copy 6",
					d: "M8.75 14.1667H7.91667C7.68655 14.1667 7.5 14.3532 7.5 14.5834V15.4167C7.5 15.6468 7.68655 15.8334 7.91667 15.8334H8.75C8.98012 15.8334 9.16667 15.6468 9.16667 15.4167V14.5834C9.16667 14.3532 8.98012 14.1667 8.75 14.1667Z",
					fill: ""
				})
			]
		})
	})
});
export default SvgVps;
